(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolongation/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/prolongation/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.prolongation = svs.numbergames.prolongation || {};
svs.numbergames.prolongation.collections = svs.numbergames.prolongation.collections || {};
svs.numbergames.prolongation.views = svs.numbergames.prolongation.views || {};
svs.numbergames.prolongation.logger = new svs.core.log.Logger('numbergames:prolongation');

 })(window);